<template>
  <div class="b1">
    <div class="bg"></div>
    <div class="back" @click="$router.go(-1)">
            <img src="../../assets/img/i19.png" />
            返回
        </div>
    <div class="body">
      <div class="center">
        <div class="c_input">
          <div>关键词</div>
          <input placeholder="请输入" v-model="keywords" />
        </div>
        <div class="c_input">
          <div>录入时间</div>
          <el-date-picker value-format="yyyy-MM-dd" v-model="dateList" type="daterange" range-separator="至"
            start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions">
          </el-date-picker>
        </div>
        <el-button type="primary" size="small" plain @click="search">搜索</el-button>
        <el-button size="small" plain @click="reset">重置</el-button>
      </div>
      <div class="info">
        <img :src="webImg + stuInfo.avatar" />
        <div>{{ stuInfo.name }}的档案报告</div>
        <div>总数：{{ total }}</div>
      </div>
      <div class="bottom">
        <el-table :header-cell-style="{ background: '#F7F8FA' }" :data="list" style="width: 100%;" :height="'100%'">
          <el-table-column prop="stuNo" label="序号">
            <template slot-scope="scope">
              <div>{{ scope.$index + 1 }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="evaluate" label="报告内容" width="600">
            <template slot-scope="scope">
              <div class="line5_" :title="scope.row.evaluate">{{ scope.row.evaluate||'AI生成中...' }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="recordTotal" label="选择记录数量"></el-table-column>
          <el-table-column prop="createTime" label="生成时间"></el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button type="primary" size="small" plain @click="btn_open(scope.row)">查看</el-button>
              <el-button type="danger" size="small" plain @click="btn_del(scope.row.id)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNum"
        :page-sizes="[10, 20, 50]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <el-dialog append-to-body :visible.sync="dialogVisible" width="972">
      <div class="pop">
        <!-- <div class="p_top">
          <div>{{stuInfo.name}}</div>
          <div>班级：初中三班 | 评价次数：64 | 评价老师：3人</div>
        </div> -->
        <div class="p_center">
          <div class="pc_left">
            <div>分析结果</div>
            <div>记录数：{{ popInfo.recordTotal }}</div>
          </div>
          <div class="pc_right">生成时间：{{ popInfo.createTime }}</div>
        </div>
        <div class="p_bottom" v-html="markedt(popInfo.evaluate)"></div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  studentPersonalFileList,
  studentInfo,
  personalFileRemove
} from '@/apis/index'
import MarkdownIt from 'markdown-it'
import '@/assets/katex/dist/katex.min.css';
import markdownItKatex from '@iktakahiro/markdown-it-katex';

const markdownRender = new MarkdownIt({
  html: true,
  linkify: true,
  typographer: true,
  breaks: true
});
markdownRender.use(markdownItKatex);
export default {
  data() {
    return {
      dialogVisible: false,
      list: [],
      pageNum: 1,
      pageSize: 10,
      total: 0,
      studentId: this.$route.query.studentId || '',
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      keywords: '',
      dateList: ['',''],
      popInfo: {},
      stuInfo: {}
    }
  },
  mounted() {
    this.getStudentInfo()
    this.getList()
  },
  methods: {
    markedt(markdown) {

      if (markdown) {
        return markdownRender.render(markdown);
      }
      return '';
    },
    btn_del(id) {
      this.$confirm('是否确定删除该记录?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        personalFileRemove(id).then(res => {
          console.log(res, 'personalFileRemove');
          this.pageNum = 1
          this.getList()
          this.$message({
            type: 'success',
            message: '删除成功!'
          });
        })
      })
    },
    search() {
      this.pageNum = 1
      this.getList()
    },
    reset() {
      this.keywords = ''
      this.dateList = ['','']
      this.pageNum = 1
      this.getList()
    },

    getStudentInfo() {
      studentInfo(this.studentId).then(res => {
        console.log(res, 'studentInfo');
        this.stuInfo = res.data
      })
    },
    btn_open(row) {
      this.popInfo = {}
      if(row.evaluate.trim() == ''){
        return this.$message.warning('AI生成中...')
      }
      this.dialogVisible = true
      this.popInfo = row
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.pageNum = 1
      this.pageSize = val
      this.getList()
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.pageNum = val
      this.getList()
    },

    getList() {
      studentPersonalFileList(this.studentId, this.pageNum, this.pageSize, this.keywords, this.dateList[0], this.dateList[1]).then(res => {
        console.log(res, 'questionGroupList');
        if (this.pageNum == 1) {
          this.list = []
        }
        this.total = res.data.total
        this.list = res.data.list
      })
    },
  }
}
</script>

<style lang="scss" scoped>
::v-deep {
  .el-range__icon {
    line-height: 20px !important;
  }

  .el-range-separator {
    line-height: 20px !important;
  }

  .el-range__close-icon {
    line-height: 20px !important;

  }

  ol,
  ul {
    padding-left: 2em;

  }

  li {
    list-style: decimal !important;
  }

  code {
    /*元素内的空白保留，并允许换行*/
    white-space: pre-wrap !important;
    /*是否允许在单词内断句*/
    word-wrap: break-word !important;
    // font-family: PingFang;
  }

  .katex-html {
    // display: none !important;
  }

  annotation {
    display: none !important;
  }

  table {
    // border-collapse: collapse;
    /* 确保表格的边框线会合并为单一的线条 */
    // border: 1px solid black;
    /* 设置表格的边框 */
  }

  td,
  th {
    // border: 1px solid black;
    /* 设置单元格的边框 */
  }

  h1 {
    font-size: 16px;
    font-weight: bold;
  }

  h2 {
    font-size: 16px;
    font-weight: bold;
  }

  h3 {
    font-size: 16px;
    font-weight: bold;
  }
  h4 {
    font-size: 16px;
    font-weight: bold;
  }

  p {
    font-size: 16px;
  }

  li {
    font-size: 16px;
  }
}

.line1_ {
  word-break: break-all;
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}

.line2_ {
  word-break: break-all;
  display: -webkit-box !important;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.b1 {
  width: 100%;
  height: 100%;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  z-index: 1;

  .bg {
    width: 100%;
    height: 228px;
    background: linear-gradient(180deg, #F3F5FA 0%, #FFFFFF 100%);
    position: absolute;
    top: 0;
    left: 0;
    z-index: -1;
  }
}

.back {
  width: 1200px;
  display: flex;
  align-items: center;
  font-weight: bold;
  font-size: 14px;
  color: #000000;
  // margin-bottom: 10px;
  margin-top: 10px;
  cursor: pointer;
  box-sizing: border-box;

  img {
    width: 14px;
    height: 14px;

  }
}

.pop {
  width: 100%;
  box-sizing: border-box;
  // padding: 30px;

  .p_top {
    width: 100%;
    height: 130px;
    background: #2992FF;
    border-radius: 10px 10px 10px 10px;
    box-sizing: border-box;
    padding: 20px;

    div:nth-child(1) {
      font-weight: bold;
      font-size: 28px;
      color: #FFFFFF;
    }

    div:nth-child(2) {
      font-weight: 500;
      font-size: 18px;
      color: #FFFFFF;
      margin-top: 24px;
    }
  }

  .p_center {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 0px 0 25px 0;

    .pc_left {
      display: flex;
      align-items: center;

      div:nth-child(1) {
        font-weight: bold;
        font-size: 18px;
        color: #000000;
      }

      div:nth-child(2) {
        width: fit-content;
        height: 20px;
        border-radius: 6px 6px 6px 6px;
        border: 1px solid #5AA7F7;
        padding: 0 8px;
        font-weight: 500;
        font-size: 12px;
        color: #5AA7F7;
        line-height: 20px;
        margin-left: 20px;
      }
    }

    .pc_right {}
  }

  .p_bottom {
    width: 100%;
    height: 500px;
    overflow-y: scroll;
  }
}

.body {
  width: 1200px;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
  padding-bottom: 20px;

  .info {
    width: 100%;
    display: flex;
    align-items: center;
    // margin: 40px 0;
    margin-bottom: 40px;

    img {
      width: 50px;
      height: 50px;
      border-radius: 90px 90px 90px 90px;
      border: 1px solid #FFFFFF;
    }

    div:nth-child(2) {
      font-weight: bold;
      font-size: 20px;
      color: #000000;
      margin: 0 20px;
    }

    div:nth-child(3) {
      font-weight: 500;
      font-size: 14px;
      color: #999999;
    }
  }

  .center {
    width: 100%;
    display: flex;
    align-items: center;
    margin: 40px 0;

    .c_input {
      display: flex;
      align-items: center;

      .el-range-editor {
        margin-left: 20px;
        width: 280px;
        height: 32px;
        background: #FFFFFF;
        border-radius: 2px 2px 2px 2px;
        border: 1px solid #CED4DB;
        margin-right: 20px;

      }

      div {
        font-weight: 400;
        font-size: 12px;
        color: #333333;
      }

      input {
        margin-left: 20px;
        width: 280px;
        height: 32px;
        background: #FFFFFF;
        border-radius: 2px 2px 2px 2px;
        border: 1px solid #CED4DB;
        box-sizing: border-box;
        padding: 0 12px;
        margin-right: 20px;
      }
    }
  }

  .bottom {
    width: 100%;
    height: 0;
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 20px;
  }
}

.line5_ {
  word-break: break-all;
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 5;
  -webkit-box-orient: vertical;
}
</style>
